import { configureStore } from '@reduxjs/toolkit';
import React, { forwardRef, useState } from 'react';

import ListItem, { IListItem } from './components/ListItem/listItem';
import SuspenseList from './components/SuspenseList';
import WrapperProvider from './components/WrapperProvider';
import { getRandomInt } from './functions';
import PropsProvider from './providers/propsProvider';
import { getListItemSlice } from './store/slices/listItemSlice';

const storeStores: { [key: string]: any } = {};

const getStore = (name: string) => {
    if (storeStores[name]) {
        return storeStores[name];
    }

    storeStores[name] = configureStore({
        reducer: {
            listItem: getListItemSlice(name),
        },
    });

    return storeStores[name];
};

const outListItem = forwardRef<any, Omit<IListItem, 'prefixStore'>>(
    ({ nameList, environment, extraFields, style, ...restProps }, ref) => {
        const [prefixStore] = useState<string>(`${getRandomInt(1, 1000)}`);

        return (
            <WrapperProvider environment={environment} store={getStore(nameList + prefixStore)}>
                <PropsProvider nameList={nameList} prefixStore={prefixStore} extraFields={extraFields}>
                    <SuspenseList style={style}>
                        {
                            // @ts-ignore
                            <ListItem ref={ref} {...(restProps as IListItem)} style={style} />
                        }
                    </SuspenseList>
                </PropsProvider>
            </WrapperProvider>
        );
    },
);

export default outListItem;
